import { FormAPI, ProcessAPI} from 'lecom-api';
import { formatDate, padNumber, formatProcessInstanceId, changeDecimalString } from './formatting_utils';
import ActivityStatuses from '../process/constants/activity_statuses';
import FormFieldTypes from '../form/constants/form_field_types.js';
import moment from 'moment-timezone';
import { getTimeZone, getFormatDate } from 'utils/timeZone';
import sanitizeHtml from 'sanitize-html';
import { formatDateToBasic } from 'utils/date_utils_new.js';

export const printForm = (formStoreId) => {
	const processCurrent = ProcessAPI.currentProcess().processInstanceData();
	const formAPI = FormAPI.form(formStoreId);
	const groupsApi = formAPI.groups();
	const fieldsAPI = formAPI.fields();

	let styles = '';
	let headerProcess = '';
	let strPrint = '';

	let modelTitle = processCurrent.title;
	let userName = processCurrent.userName;
	let statusProcess = processCurrent.status;
	let codeProcess = processCurrent.processInstanceId;
	let titleActivity = processCurrent.activityTitle;
	let cycleActivity = processCurrent.cycle;
	let startDateActivity = processCurrent.activityStartDate;
	let finishDateActivity = processCurrent.activityCompleteDate;

	function translatedProcessStatusName() {
		return Object.keys(ActivityStatuses).reduce((previousValue, statusKey) => {
			if(ActivityStatuses[statusKey] == statusProcess)
				return Realize.i18n.t(`activity.status.${statusKey}`);

			return previousValue;
		}, statusProcess);
	}

	function verifyDate(finishDateActivity){
		if(finishDateActivity !== null){
			return `
				<div class="info">
					<span class="info-status"><div class="start-activity">${Realize.i18n.t('activity.start_date')}</div> <strong>${formatDate(startDateActivity)}</strong></span>
				</div>
				<div class="info-date">
					<span class="date-acitivity"><div class="finish-activity">${Realize.i18n.t('activity.finish_date')}</div> <strong>${formatDate(finishDateActivity)}</strong></span>
				</div>
			`;
		} else {
			return `
				<div class="info">
					<span class="info-status">${Realize.i18n.t('activity.start_date')} <strong>${formatDate(startDateActivity)}</strong></span>
				</div>
			`;
		}
	}

	function verifyValue(value){
		if(value === null || value === undefined || value === NaN){
			return true;
		}

		return false;
	}

	function verifyLabel(valueLabel, valueName){
		let value = (valueLabel !== undefined && valueLabel !== null) ? String(valueLabel) : '';

		return value
	}

	function clear(value){
		return sanitizeHtml(value, {
			allowedTags: [ 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
			'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
			'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre' ],
			allowedAttributes: {
			a: [ 'href', 'name', 'target' ],
			img: [ 'src' ]
			},
			selfClosing: [ 'img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
			allowedSchemes: [ 'http', 'https', 'mailto' ],
			allowedSchemesByTag: {}
		});
	}

	function verifyLineBreak(lineBreak){
		if(lineBreak === 'SIMPLES'){
			strPrint += `
				<div class="line-break col s12">
					<div class="divider simples"></div>
				</div>
			`;
		}

		if(lineBreak === 'BARRA_SEPARADORA'){
			strPrint += `
				<div class="line-break col s12">
					<div class="divider barra-separadora"></div>
				</div>
			`;
		}
	}

	styles = `
		<style>
			html, body {
				font-family: Arial, Helvetica, sans-serif;
				-webkit-print-color-adjust: exact;
			}

			.print-form.header {
				display: flex;
			}

			.print-form .username {
				width: 50%;
				text-align: left;
				padding: 0 20px;
			}

			.print-form .info {
				width: 50%;
				text-align: right;
			}

			.print-form .info-status, .print-form .info-cod {
				display: inline-block;
				text-align: left;
				margin: 0 20px;
			}

			.print-form .info-status strong, .print-form .info-cod strong {
				display: block;
			}

			.print-form.header {
				margin: 10px;
				padding: 10px;
				border-bottom: 1px solid #000;
			}

			.print-form .info-activity {
				width: 50%;
				text-align: left;
				padding: 0 20px;
			}

			.print-form .cycle-activity{
				color: #999999;
				font-size: 11px;
				font-style: italic;
			}

			.print-form .info-date {
				display: inline-block;
				text-align: left;
				margin: 0 20px;
			}

			.print-form .info-date strong {
				display: block;
			}

			.print-form.fields {
				float: left;
			}

			.print-form.fields .padding-field {
				margin: 5px;
				padding: 5px;

			}

			.print-form.fields .table-grid {
				border-collapse: collapse;
			}

			.print-form.fields .table-grid td,
			.print-form.fields .table-grid th {
				vertical-align: baseline;;
				padding: 5px;
				text-align: left;
				font-size: 13px;
			}

			.print-form.fields .table-grid tbody tr {
				background: #fff;
			}

			.print-form.fields.m1 {
				width: 8.3333333333%;
			}

			.print-form.fields.m2 {
				width: 16.66666667%;
			}

			.print-form.fields.m3 {
				width: 25%;
			}

			.print-form.fields.m4 {
				width: 33.33333333%;
			}

			.print-form.fields.m5 {
				width: 41.66666667%%;
			}

			.print-form.fields.m6 {
				width: 50%;
			}

			.print-form.fields.m7 {
				width: 58.33333333%;
			}

			.print-form.fields.m8 {
				width: 66.66666667%;
			}

			.print-form.fields.m9 {
				width: 75%;
			}

			.print-form.fields.m10 {
				width: 83.33333333%;
			}

			.print-form.fields.m11 {
				width: 91.66666667%;
			}

			.print-form.fields.m12 {
				width: 100%;
			}

			.print-form .label-field {
				margin-bottom: 2px;
				display: block;
				font-weight: bold;
				font-size: 12px;
				opacity: 0.54;
				font-weight: initial;
			}

			.print-form .value-field {
				display: block;
				font-size: 13px;
			}

			.print-form.fields.label{
				width: 100%;
				margin: 10px 0;
			}

			.container {
				display: block;
				position: relative;
				padding-left: 27px;
				margin-bottom: 12px;
				cursor: pointer;
				font-size: 22px;
				-webkit-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
			}

			.container input {
				position: absolute;
				opacity: 0;
				cursor: pointer;
			}

			.checkmark {
				position: absolute;
				top: 0;
				left: 0;
				height: 18px;
				width: 18px;
				background-color: #000000;
			}

			.container input:checked ~ .checkmark {
				background-color: #000000;
			}

			.container input {
				background-color: #000000;
			}

			.checkmark:after {
				content: "";
				position: absolute;
				display: none;
			}

			.container input:checked ~ .checkmark:after {
				display: block;
			}

			.container input {
				display: block;
			}

			.container .checkmark:after {
				left: 5px;
				top: 3px;
				width: 5px;
				height: 7px;
				border: solid white;
				border-width: 0 3px 3px 0;
				-webkit-transform: rotate(45deg);
				-ms-transform: rotate(45deg);
				transform: rotate(45deg);
			}

			.start-activity, .finish-activity{
				font-size: 14px;
				margin-bottom: 2px;
			}

			.divider{
				overflow: hidden;
			}

			.line-break.col.s12{
				width: 100%;
				margin-left: 0;
				float: left;
			}

			.divider.simples{
				height: 5px;
				background-color: transparent !important;
			}

			.divider.barra-separadora{
				height: 3px;
				background-color: #000;
				margin: 30px 0px 15px;
				opacity: .4;
				margin: 30px 10px 5px 10px;
				overflow: hidden;
				width: calc(100% - 20px);
			}

			.border-group {
				height: 3px;
				background-color: #000000;
				opacity: .4;
   				margin: 30px 10px 5px 10px;
				overflow: hidden;
				width: calc(100% - 20px);
			}

			.name-group {
				font-size: 17px;
				color: #000000;
				font-weight: bold;
				position: relative;
				padding: 0.75rem;
				width: 100%;
				display: inline-block;
			}

			.current-data-row-td{
				width: 75%;
			}

			.color-current-label{
				opacity: 0.54;
				font-size: 12px !important;
			}

		</style>
	`;

	headerProcess = `
		<div class="print-form header">
			<div class="username">
				<span><strong>${modelTitle}</strong> ${Realize.i18n.t('by')} <strong>${userName}</strong></span>
			</div>
			<div class="info">
				<div class="info-status">
					<span class="status">${Realize.i18n.t('processInstance.status')} <strong>${translatedProcessStatusName(statusProcess)}</strong></span>
				</div>
				<div class="info-cod">
					<span class="cod">${Realize.i18n.t('processInstance.code')} <strong>${formatProcessInstanceId(codeProcess)}</strong></span>
				</div>
			</div>
		</div>
		<div class="print-form header activity">
			<div class="info-activity">
				<span class="title-activity"><strong>${titleActivity}</strong></span>
				<span class="cycle-activity">${Realize.i18n.t('activity.cycle')}: ${padNumber(cycleActivity, 2)}</span>
			</div>
			${verifyDate(finishDateActivity)}
		</div>
	`;

	for(var x=0; x <= groupsApi.length -1; x++){
		let currentGroup = groupsApi[x];
		let currentNameGroup = currentGroup._name;
		let fieldsGroup = currentGroup.fields();

		if(currentGroup.visible() === true && fieldsGroup.length){
			strPrint += `
				<div>
					${currentNameGroup === '' ? '' : '<div class="border-group"></div>'}
					<div class="name-group">
						<label>${currentNameGroup}</label>
					</div>
				</div>
			`;
		}

		for(var i=0; i <= fieldsGroup.length -1; i++){
			let currentField = fieldsGroup[i];

			if(currentField.visible() && !currentField.hidden()){
				if(currentField.type() !== FormFieldTypes.LABEL && currentField.type() !== FormFieldTypes.DATE && currentField.type() !== FormFieldTypes.GRID && currentField.type() !== FormFieldTypes.CHART && currentField.type() !== FormFieldTypes.NUMBER && currentField.type() !== FormFieldTypes.CURRENCY && currentField.type() !== FormFieldTypes.DECIMAL && currentField.type() !== FormFieldTypes.DOCUMENT && currentField.type() !== FormFieldTypes.CHECKBOX && currentField.type() !== FormFieldTypes.TEXTAREA && currentField.type() !== FormFieldTypes.AUTOCOMPLETE && currentField.type() !== FormFieldTypes.RADIO){
					if(verifyValue(currentField.value())){
						strPrint += `
							<div class="print-form fields ${currentField.className()}">
								<div class="padding-field">
									<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
								</div>
							</div>
						`;
					} else {
						strPrint += `
							<div class="print-form fields ${currentField.className()}">
								<div class="padding-field">
									<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
									<label class="value-field">${clear(currentField.value())}</label>
								</div>
							</div>
						`;
					}
					verifyLineBreak(currentField.lineBreak());
				}
				else if (currentField.type() === FormFieldTypes.DATE){
					let currenteFieldValue = currentField.value() || "";
					let valueIncludes = currenteFieldValue ? currenteFieldValue.includes('-') : "";
					let valueFormated = currenteFieldValue !== '' && currenteFieldValue !== null ? currenteFieldValue.substr(0, 10).split('-').reverse().join('/') : '';

					if(valueIncludes === true){
						if(verifyValue(currentField.value())){
							strPrint += `
								<div class="print-form fields ${currentField.className()}">
									<div class="padding-field">
										<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
									</div>
								</div>
							`;
						} else {
							strPrint += `
								<div class="print-form fields ${currentField.className()}">
									<div class="padding-field">
										<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
										<label class="value-field">${clear(valueFormated)}</label>
									</div>
								</div>
							`;
						}
						verifyLineBreak(currentField.lineBreak());
					} else {
						if(verifyValue(currentField.value())){
							strPrint += `
								<div class="print-form fields ${currentField.className()}">
									<div class="padding-field">
										<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
									</div>
								</div>
							`;
						} else {
							strPrint += `
								<div class="print-form fields ${currentField.className()}">
									<div class="padding-field">
										<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
										<label class="value-field">${clear(currenteFieldValue)}</label>
									</div>
								</div>
							`;
						}
						verifyLineBreak(currentField.lineBreak());
					}
				}

				else if (currentField.type() === FormFieldTypes.GRID) {
					let nameGrid = currentField.name();
					let columns = currentField.columns();
					let currentFieldGrid = currentField.dataRows();

					strPrint += `
						<div class="line-break col s12">
							<div class="divider barra-separadora"></div>
						</div>
						<div class="print-form fields ${currentField.className()}">
							<div class="padding-field">
								<table class="table-grid">
					`;

					for(let dataRow=0; dataRow <= currentFieldGrid.length -1; dataRow++){
						let currentDataRow = currentFieldGrid[dataRow];

						for (let colDataRow = 0; colDataRow <= columns.length -1; colDataRow++ ) {
							let currentFormat = columns[colDataRow].format;
							let currentLabel = columns[colDataRow].label;
							let getFieldsGrid = formAPI.get("fields");
							let gridField = getFieldsGrid[nameGrid];
							let columnsGrid = gridField.columns[colDataRow];
							let visibleColumnsGrid = columnsGrid.visible;

							const fieldGridApi = currentField.fields(columnsGrid.name);
							const fieldMaxLength =  fieldGridApi.maxLength();
							const fieldDigits = fieldGridApi.digits();
							const fieldComp = fieldGridApi.component();
							const fieldPrefix = fieldGridApi.prefix();
							const fieldApiGrid = currentField.fields(columnsGrid.name);

							if(visibleColumnsGrid !== false){
								if(currentFormat === 'currency' || currentFormat === 'number'){
									if(currentDataRow[columns[colDataRow].name] != null){
										const fieldValue = changeDecimalString(currentDataRow[columns[colDataRow].name], fieldMaxLength, fieldDigits, fieldComp, fieldPrefix, true);

										strPrint += `
											<tr>
												<td class="color-current-label">${currentLabel || ''}</td>
												<td class="current-data-row-td">${fieldValue}</td>
											</tr>
										`;
									} else {
										strPrint += `
											<td></td>
										`;
									}
								}
								else if(currentFormat === 'decimal'){
									if(currentDataRow[columns[colDataRow].name] === null || currentDataRow[columns[colDataRow].name] === undefined || isNaN(currentDataRow[columns[colDataRow].name] || currentDataRow[columns[colDataRow].name] === "")){
										strPrint += `
											<td></td>
										`;
									} else {
										const fieldValue = changeDecimalString(currentDataRow[columns[colDataRow].name], fieldMaxLength, fieldDigits, fieldComp, fieldPrefix, true);

										strPrint += `
											<tr>
												<td class="color-current-label">${currentLabel || ''}</td>
												<td>${fieldValue}</td>
											</tr>
										`;
									}
								}
								else if(currentFormat === 'document'){
									if(currentDataRow[columns[colDataRow].name] === null || currentDataRow[columns[colDataRow].name] === undefined || currentDataRow[columns[colDataRow].name] === NaN || currentDataRow[columns[colDataRow].name].length  === 0 || currentDataRow[columns[colDataRow].name] === ""){
										strPrint += `
											<td></td>
										`;
									} else {
										strPrint += `
											<tr>
												<td class="color-current-label">${currentLabel || ''}</td>
												<td>${currentDataRow[columns[colDataRow].name].split(":")[0]}</td>
											</tr>
										`;
									}
								}
								else if(currentFormat === 'date'){
									if(currentDataRow[columns[colDataRow].name] === null || currentDataRow[columns[colDataRow].name] === undefined || currentDataRow[columns[colDataRow].name] === NaN || currentDataRow[columns[colDataRow].name].length  === 0 || currentDataRow[columns[colDataRow].name] === ""){
										strPrint += `
											<td></td>
										`;
									} else {
										let validateValue = currentDataRow[columns[colDataRow].name] ? true : false
										let verifyDateMoment = moment.tz(currentDataRow[columns[colDataRow].name], getFormatDate(currentDataRow[columns[colDataRow].name]), getTimeZone()).utc();

										if(validateValue && verifyDateMoment._isValid === false){
											strPrint += `
												<tr>
													<td class="color-current-label">${currentLabel || ''}</td>
													<td>${formatDateToBasic(currentDataRow[columns[colDataRow].name])}</td>
												</tr>
											`;
										} else {
											let verify = new RegExp('/');
											let verifyDate = verify.test(currentDataRow[columns[colDataRow].name]);

											if(verifyDate === false){
												strPrint += `
													<tr>
														<td class="color-current-label">${currentLabel || ''}</td>
														<td>${formatDateToBasic(currentDataRow[columns[colDataRow].name])}</td>
													</tr>
												`;
											}
											else {
												strPrint += `
													<tr>
														<td class="color-current-label">${currentLabel || ''}</td>
														<td>${currentDataRow[columns[colDataRow].name]}</td>
													</tr>
												`;
											}
										}
									}
								}
								else if(fieldApiGrid.type() === FormFieldTypes.AUTOCOMPLETE || fieldApiGrid.type() === FormFieldTypes.RADIO){
									let newValueListGrid = "";
									let valueListGrid = currentDataRow[columns[colDataRow].name];
									const optionsListGrid = fieldApiGrid.options() || [];

									if (valueListGrid !== undefined && valueListGrid !== null) {
										let findResult = {};

										if (Array.isArray(valueListGrid) && valueListGrid.length)
											findResult = optionsListGrid.find(opt => opt.value === valueListGrid[0]);
										else if (typeof valueListGrid === 'object' && Object.keys(valueListGrid).length && valueListGrid.value)
											findResult = optionsListGrid.find(opt => opt.value === valueListGrid.value);
										else
											findResult = optionsListGrid.find(opt => opt.value === valueListGrid);

										newValueListGrid = typeof findResult === 'object' && Object.keys(findResult).length && findResult.name ? findResult.name : "";

										if (newValueListGrid === null || newValueListGrid === undefined || newValueListGrid === "")
											newValueListGrid = String(valueListGrid);
									}

									if (newValueListGrid === null || newValueListGrid === undefined || newValueListGrid === "") {
										strPrint += `
											<td></td>
										`;
									} else {
										strPrint += `
											<tr>
												<td class="color-current-label">${currentLabel || ''}</td>
												<td>${newValueListGrid}</td>
											</tr>
										`;
									}
								}
								else {
									if(currentDataRow[columns[colDataRow].name] === null || currentDataRow[columns[colDataRow].name] === undefined || currentDataRow[columns[colDataRow].name] === NaN || currentDataRow[columns[colDataRow].name] === "" || currentDataRow[columns[colDataRow].name].length === 0){
										strPrint += `
											<td></td>
										`;
									} else {
										strPrint += `
											<tr>
												<td class="color-current-label">${currentLabel || ''}</td>
												<td>${currentDataRow[columns[colDataRow].name]}</td>
											</tr>
										`;
									}
								}
							}
						}

						if (currentFieldGrid.length -1 !== dataRow) {
							strPrint += `
								<tr><td colspan="2"><hr></td></tr>
							`;
						}
					}

					strPrint += `
								</table>
							</div>
						</div>
					`;
				}

				else if(currentField.type() === FormFieldTypes.LABEL){
					let labelName = clear(currentField.label());
					let labelBackgroundColor = currentField.backgroundColor();
					let labelColor = currentField.color();
					let labelSize = currentField.size();
					let labelAlign = currentField.align();

					if(labelSize === 'SMALL'){
						strPrint += `
							<div style="background-color: ${labelBackgroundColor}" class="print-form fields label">
								<p style="color:${labelColor}; padding: 0 10px; font-size:${labelSize}; text-align: ${labelAlign}">${labelName}</p>
							</div>
						`;
					}
					else if(labelSize === 'MEDIUM'){
						strPrint += `
							<div style="background-color: ${labelBackgroundColor}" class="print-form fields label">
								<p style="color:${labelColor}; padding: 0 10px; font-size:${labelSize}; text-align: ${labelAlign}">${labelName}</p>
							</div>
						`;
					}
					else if(labelSize === 'LARGE'){
						strPrint += `
							<div style="background-color: ${labelBackgroundColor}" class="print-form fields label">
								<p style="color:${labelColor}; padding: 0 10px; font-size:${labelSize}; text-align: ${labelAlign}">${labelName}</p>
							</div>
						`;
					}
					verifyLineBreak(currentField.lineBreak());
				}
				else if(currentField.type() === FormFieldTypes.DECIMAL || currentField.type() === FormFieldTypes.CURRENCY || currentField.type() === FormFieldTypes.NUMBER){
					if(verifyValue(currentField.value())){
						strPrint += `
							<div class="print-form fields ${currentField.className()}">
								<div class="padding-field">
									<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
								</div>
							</div>
						`;
					} else {
						const currencyMaxLength =  currentField.maxLength();
						const currencyDigits = currentField.digits();
						const currencyComp = currentField.component();
						const currencyPrefix = currentField.prefix();
						const currencyValue = changeDecimalString(currentField.value(), currencyMaxLength, currencyDigits, currencyComp, currencyPrefix, true);

						strPrint += `
							<div class="print-form fields ${currentField.className()}">
								<div class="padding-field">
									<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
									<label class="value-field">${clear(currencyValue)}</label>
								</div>
							</div>
						`;
					}
					verifyLineBreak(currentField.lineBreak());
				}
				else if(currentField.type() === FormFieldTypes.DOCUMENT){
					if(verifyValue(currentField.value())){
						strPrint += `
							<div class="print-form fields ${currentField.className()}">
								<div class="padding-field">
									<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
								</div>
							</div>
						`;
					} else {
						strPrint += `
							<div class="print-form fields ${currentField.className()}">
								<div class="padding-field">
									<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
									<label class="value-field">${clear(currentField.value().split(":")[0])}</label>
								</div>
							</div>
						`;
					}
					verifyLineBreak(currentField.lineBreak());
				}
				else if(currentField.type() === FormFieldTypes.CHECKBOX){
					let checkboxValue = currentField.value();

					if(checkboxValue === '' || checkboxValue === undefined || checkboxValue === null){
						strPrint += `
							<div class="print-form fields ${currentField.className()}">
								<div class="padding-field">
									<label class="label-field container">
										<input type="checkbox" name="teste" value="teste">
										${verifyLabel(currentField.label(), currentField.name())}
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
						`;
					} else {
						strPrint += `
							<div class="print-form fields ${currentField.className()}">
								<div class="padding-field">
									<label class="label-field container">
										<input type="checkbox" checked="checked">
											${verifyLabel(currentField.label(), currentField.name())}
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
						`;
					}
					verifyLineBreak(currentField.lineBreak());
				}
				else if(currentField.type() === FormFieldTypes.TEXTAREA){
					const history = currentField.history();
					const propsHistory = currentField.historyProps();

					if(history === true){
						if(verifyValue(currentField.value())){
							strPrint += `
								<div class="print-form fields ${currentField.className()}">
									<div class="padding-field">
										<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
									</div>
								`;

									for(let h=0; h <= propsHistory.length -1; h++){
										let currentHistory = propsHistory[h];
										let historyActivityName = currentHistory.activityName;
										let historyResponsible = currentHistory.responsible;
										let historyExecutionDate = currentHistory.executionDate;
										let historyDescription = currentHistory.description;

										strPrint += `
											<div class="padding-field">
												<label class="label-field">${historyActivityName} ${Realize.i18n.t('history.by')} ${historyResponsible} ${Realize.i18n.t('history.in')} ${formatDateToBasic(historyExecutionDate)}</label>
												<label class="value-field">${clear(historyDescription)}</label>
											</div>
										`;
									}

							strPrint += `
								</div>
							`;
						} else {
							strPrint += `
								<div class="print-form fields ${currentField.className()}">
									<div class="padding-field">
										<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
										<label class="value-field">${clear(currentField.value().replace(/\n/g, "<br/>"))}</label>
									</div>
							`;

							for(let h=0; h <= propsHistory.length -1; h++){
								let currentHistory = propsHistory[h];
								let historyActivityName = currentHistory.activityName;
								let historyResponsible = currentHistory.responsible;
								let historyExecutionDate = currentHistory.executionDate;
								let historyDescription = currentHistory.description;

								strPrint += `
									<div class="padding-field">
										<label class="label-field">${historyActivityName} ${Realize.i18n.t('history.by')} ${historyResponsible} ${Realize.i18n.t('history.in')} ${formatDateToBasic(historyExecutionDate)}</label>
										<label class="value-field">${clear(historyDescription)}</label>
									</div>
								`;
							}

							strPrint += `
								</div>
							`;
						}
					} else {
						if(verifyValue(currentField.value())){
							strPrint += `
								<div class="print-form fields ${currentField.className()}">
									<div class="padding-field">
										<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
									</div>
								</div>
							`;
						} else {
							strPrint += `
								<div class="print-form fields ${currentField.className()}">
									<div class="padding-field">
										<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
										<label class="value-field">${clear(currentField.value().replace(/\n/g, "<br/>"))}</label>
									</div>
								</div>
							`;
						}
					}

					verifyLineBreak(currentField.lineBreak());
				}
				else if(currentField.type() === FormFieldTypes.AUTOCOMPLETE || currentField.type() === FormFieldTypes.RADIO){
					let newValueList = "";
					let valueList = currentField.value();
					const optionsList = currentField.options() || [];

					if (valueList !== undefined && valueList !== null) {
						let findResult = {};

						if (Array.isArray(valueList) && valueList.length)
							findResult = optionsList.find(opt => opt.value === valueList[0]);
						else if (typeof valueList === 'object' && Object.keys(valueList).length && valueList.value)
							findResult = optionsList.find(opt => opt.value === valueList.value);
						else
							findResult = optionsList.find(opt => opt.value === valueList);

						newValueList = typeof findResult === 'object' && Object.keys(findResult).length && findResult.name ? findResult.name : "";

						if (newValueList === null || newValueList === undefined || newValueList === "")
							newValueList = String(valueList);
					}

					if(verifyValue(currentField.value())){
						strPrint += `
							<div class="print-form fields ${currentField.className()}">
								<div class="padding-field">
									<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
								</div>
							</div>
						`;
					} else {
						strPrint += `
							<div class="print-form fields ${currentField.className()}">
								<div class="padding-field">
									<label class="label-field">${verifyLabel(currentField.label(), currentField.name())}</label>
									<label class="value-field">${clear(newValueList)}</label>
								</div>
							</div>
						`;
					}

					verifyLineBreak(currentField.lineBreak());
				}
			}
		}
	}

	strPrint = styles + headerProcess + strPrint;

	// document.write(strPrint);
	$("#iframe-print").remove();
	let iframe = $("<iframe id='iframe-print' src='about:blank'></iframe>").hide().prependTo( "html" );
	iframe = iframe[0].contentWindow || iframe[0].contentDocument.document || iframe[0].contentDocument;
	iframe.document.write(strPrint);
	iframe.document.close();
	let contentWindow = document.getElementById("iframe-print").contentWindow;
    let result = contentWindow.document.execCommand('print', false, null);
    if(!result) contentWindow.print();

}

export const PrintFormUtils = {
	printForm
};

export default PrintFormUtils;
